import React, { useState, useEffect } from "react";
import { MDBBtn, MDBRow } from "mdb-react-ui-kit";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import Skeleton from "@mui/material/Skeleton";
import axios from "axios";
//
import { validate } from "../components/login/validate";
// config
import configData from "../config/config.json";
// components
import MetaTagsBusinessOwners from "../components/meta-tags-seo/MetaTagsBusinessOwners";
import RegisterBusiness from "./RegisterBusiness";
import AlertError from "../components/AlertError/AlertError";
// img
import imgg from "../images/register-business/01.png";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const RegisterBusinessStep1 = (props) => {
  const [dataCome, setDataCome] = useState(false);

  const [render, setRender] = useState(false);

  const [disable, setDisable] = useState(false);

  // data
  const [data, setData] = useState({
    LangId: 1,
    BizId: getCookie("BizId"),
    ownerId: getCookie("OwnerId"),
    EnTitle: "",
    FaTitle: "",
    EnJobTitle: "",
    FaJobTitle: "",
    OwnerType: JSON.parse(localStorage.getItem("SelectedOwner")),
    FullName: "",
  });

  const [errorAlert, setErrorAlert] = useState(null);
  const errorAlertHandeler = (lang) => {
    setErrorAlert(lang);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setErrorAlert(null);
    }, 4000);
  };

  const inputChangeHandler = (event) => {
    let val;
    if (
      event.target.name == "EnTitle" ||
      event.target.name == "EnJobTitle" ||
      event.target.name == "FullName"
    ) {
      val = event.target.value.replace(/[^A-Za-z0-9\s,]/gi, "");
      setData({ ...data, [event.target.name]: val });
      if (!/^[a-zA-Z0-9 ]*$/.test(event.target.value)) {
        errorAlertHandeler("انگلیسی");
      }
    } else {
      setData({ ...data, [event.target.name]: event.target.value });

      // val = event.target.value.replace(/[^آ-ی0-9 ]/g, "");
      // setData({ ...data, [event.target.name]: val });
      // if (!/^[آ-ی0-9 ]*$/.test(event.target.value)) {
      //   errorAlertHandeler("فارسی");
      // }
    }
  };

  // validate
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  useEffect(() => {
    setErrors(validate(data, "register-business-s1"));
  }, [data, touched]);

  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Authorization: "Bearer " + getCookie("token"),
  };

  const submitHandler = (event) => {
    event.preventDefault();

    if (!Object.keys(errors).length) {
      setDisable(true);

      // set data to api
      const postData = {
        id: getCookie("BizUuid"),
        bId: getCookie("BizId"),
        enTitle: data.EnTitle,
        faTitle: data.FaTitle,
        enJobTitle: data.EnJobTitle,
        faJobTitle: data.FaJobTitle,
        ownerType: data.OwnerType || (data.FullName !== "" ? 1 : 0),
        fullName: data.FullName,
      };

      axios
        .post(configData.API_DOMAIN + "/api/v1/Businesses", postData, {
          headers: header,
        })
        .then((response) => {
          setDisable(false);

          if (response.data.isSuccess) {
            // success
            // const items = JSON.parse(localStorage.getItem("OwnerDetail"));
            // items.BizId = response.data.BizId;
            // localStorage.setItem("OwnerDetail", JSON.stringify(items)); //set local
            // localStorage.setItem("CatId", JSON.stringify(0)); //set local
            setCookie("BizId", response.data.data.bId, 1);
            setCookie("BizUuid", response.data.data.id, 1);
            props.history.push({
              pathname: "/register-business-step2",
            });
          }
        })
        .catch((error) => {
          // alert(error);
        });
    } else {
      setTouched({
        EnTitle: true,
        EnJobTitle: true,
      });
    }
  };

  //   setCookie
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    document.cookie =
      cname +
      "=" +
      cvalue +
      ";" +
      expires +
      " domain=en-biz.gishniz.com; path=/";
    // " domain=en-biz.gishniz.app; path=/";
  }

  const [value, setValue] = useState("");

  // owner name part
  const [owner, setOwner] = useState(false);

  const handleChange = (event) => {
    // setValue(event.target.value);
    // if (event.target.value === "1") {
    //   setOwner(true);
    // } else {
    //   setOwner(false);
    // }
    // setData({ ...data, OwnerType: event.target.value, FullName: "" });
    // localStorage.setItem(
    //   "regStep1",
    //   JSON.stringify({ ...data, OwnerType: event.target.value, FullName: "" })
    // ); //set local
  };

  // this 2 state for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = React.useState({});

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "register-business-step1",
    Authorization: "Bearer " + getCookie("token"),
  };

  useEffect(() => {
    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else {
      setDataCome(false);

      // api for meta tags
      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });

      if (getCookie("BizUuid") === "00000000-0000-0000-0000-000000000000") {
        // when its first time to add new business
        axios
          .post(
            configData.API_DOMAIN + "/api/v1/Businesses/new",
            {},
            {
              headers: {
                ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
                LangId: 1,
                Authorization: "Bearer " + getCookie("token"),
              },
            }
          )
          .then((response) => {
            if (response.data.isSuccess) {
            }
          })
          .catch((error) => {
            // alert(error);
          });
      }

      // api to check and get data
      axios
        .get(
          configData.API_DOMAIN + `/api/v1/Businesses/${getCookie("BizUuid")}`, // the business Guuid that gets from login
          {
            headers: headerMeta,
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            let stepStatus = response.data.data.stepStatus;
            let data = response.data.data;

            // check user is registered or not
            if (!stepStatus.isRegistered) {
              props.history.push({
                pathname: "/signup",
              });
            }
            // check the business steps are completed or not
            else if (stepStatus.isComplete) {
              props.history.push({
                pathname: "/business-dashboard",
              });
            }
            // // check the business step number -- comment for step 1
            // else if (stepStatus.regStep < 1) {
            //   props.history.push({
            //     pathname: `/register-business-step${stepStatus.regStep}`,
            //   });
            // }
            else {
              // set data to states
              setData({
                ...data,
                EnTitle: data?.enTitle || "",
                FaTitle: data?.faTitle || "",
                EnJobTitle: data?.enJobTitle || "",
                FaJobTitle: data?.faJobTitle || "",
                FullName: data?.ownerFullName || "",
              });
              setDataCome(true);
            }
          }
        })
        .catch((error) => {
          // alert(error);
        });

      // comment for come data from mina -- load step1 api
      // axios
      //   .get(domain + "/api/biz/register/load-step1", {
      //     headers: {
      //       ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
      //       LangId: 1,
      //       OwnerId: getCookie("OwnerId"),
      //       BizId: getCookie("BizId"),
      //     },
      //   })
      //   .then((response) => {
      //     if ((response.data.msg = "done")) {
      //       if (response.data.stepData != null) {
      //         var en = response.data.stepData.EnTitle;
      //         var fa = response.data.stepData.FaTitle;
      //         var en2 = response.data.stepData.EnJobTitle;
      //         var fa2 = response.data.stepData.FaJobTitle;
      //         var fun = response.data.stepData.OwnerFullName;
      //         setData({
      //           ...data,
      //           EnTitle: en,
      //           FaTitle: fa,
      //           EnJobTitle: en2,
      //           FaJobTitle: fa2,
      //           FullName: fun,
      //         });
      //       }
      //       setDataCome(true);
      //     }
      //   })
      //   .catch((error) => {
      //     // alert(error);
      //   });
      // comment for come data from mina -- load step1 api

      setRender(true);
    }
  }, []);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return (
    <>
      {render ? (
        <>
          {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

          <RegisterBusiness />
          <div>
            {/* <CacheProvider value={cacheRtl}>
              <ThemeProvider theme={theme}> */}
            <MDBRow className="mx-0">
              <div className="col-12 col-md-8 register-business-padd">
                <div className="register-steps-right position-relative">
                  <h1 className="rb-step1-tit1">ثبت کسب‌وکار</h1>
                  <h2 className="rb-step1-tit2">
                    اطلاعات اولیه کسب‌وکار را وارد کنید.
                  </h2>
                  {dataCome ? (
                    <>
                      <CacheProvider value={cacheRtl}>
                        <ThemeProvider theme={theme}>
                          <div className="">
                            <TextField
                              type="text"
                              name="FaTitle"
                              value={data.FaTitle}
                              onChange={inputChangeHandler}
                              id="outlined-basic"
                              label="نام کسب‌‌وکار به فارسی"
                              variant="outlined"
                              className={
                                "label-field-more7 custom-text-field custom-text-field-contact my-0"
                              }
                            />
                          </div>
                        </ThemeProvider>
                      </CacheProvider>
                      <CacheProvider value={cacheRtl}>
                        <ThemeProvider theme={theme}>
                          <div className="">
                            <TextField
                              type="text"
                              name="FaJobTitle"
                              value={data.FaJobTitle}
                              onChange={inputChangeHandler}
                              id="outlined-basic"
                              label="عنوان شغلی به فارسی مانند وکیل مهاجرت، رستوران ایرانی، متخصص قلب..."
                              variant="outlined"
                              className={
                                "label-field-more7 custom-text-field custom-text-field-contact mb-0 mt-3"
                              }
                            />
                          </div>
                        </ThemeProvider>
                      </CacheProvider>
                      <div className="">
                        <div className="">
                          <TextField
                            dir="ltr"
                            type="text"
                            name="EnTitle"
                            value={data.EnTitle}
                            onChange={inputChangeHandler}
                            id="outlined-basic"
                            label="Business Name in English "
                            variant="outlined"
                            className={
                              errors.EnTitle && touched.EnTitle
                                ? "label-field-less custom-text-field custom-text-field-contact custom-text-field-error font-family-en mt-3"
                                : "label-field-less custom-text-field custom-text-field-contact mb-0 font-family-en mt-3"
                            }
                            required
                          />
                        </div>
                        {errors.EnTitle && touched.EnTitle && (
                          <span className="input-error me-1">
                            {errors.EnTitle}
                          </span>
                        )}
                      </div>
                      <div className="">
                        <div className="">
                          <TextField
                            dir="ltr"
                            type="text"
                            name="EnJobTitle"
                            value={data.EnJobTitle}
                            onChange={inputChangeHandler}
                            id="outlined-basic"
                            label="Job Title in English Example: Immigration Lawyer, Persian Restaurant, Cardiologist..."
                            variant="outlined"
                            className={
                              errors.EnJobTitle && touched.EnJobTitle
                                ? "label-field-zero custom-text-field custom-text-field-contact custom-text-field-error mt-3 font-family-en"
                                : "label-field-zero custom-text-field custom-text-field-contact mb-0 mt-3 font-family-en"
                            }
                            required
                          />
                        </div>
                        {errors.EnJobTitle && touched.EnJobTitle && (
                          <span className="input-error me-1">
                            {errors.EnJobTitle}
                          </span>
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      <Skeleton
                        className="profile-Skeleton mt-3"
                        variant="rectangular"
                        height={30}
                        animation="wave"
                      />
                      <Skeleton
                        className="profile-Skeleton mt-3"
                        variant="rectangular"
                        height={30}
                        animation="wave"
                      />
                    </>
                  )}
                  {dataCome ? (
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div
                          id=""
                          className="me-md-0 width-sm-100 width-42vw mt-5  position-relative"
                        >
                          <p className="rb-step1-text">اختیاری</p>
                          <div className="mt-12px mb-4">
                            <TextField
                              type="text"
                              id="outlined-basic"
                              label="نام مالک کسب‌و‌کار"
                              variant="outlined"
                              name="FullName"
                              value={data.FullName}
                              onChange={inputChangeHandler}
                              className={
                                "label-field-more5 custom-text-field custom-text-field-contact mb-0 mt-3"
                              }
                            />
                          </div>
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  ) : (
                    <Skeleton
                      className="profile-Skeleton  mt-5"
                      variant="rectangular"
                      height={30}
                      animation="wave"
                    />
                  )}

                  <div className=" mt-0">
                    <div className="rb-steps-btns justify-content-end">
                      {dataCome ? (
                        <MDBBtn
                          disabled={disable}
                          className="rb-steps-btn2 hov-shadow"
                          onClick={submitHandler}
                        >
                          مرحله بعدی
                        </MDBBtn>
                      ) : (
                        <Skeleton
                          className="rb-steps-btn2 h-Skeleton-39"
                          variant="rectangular"
                          width={123}
                          height={39}
                          animation="wave"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4 px-0 text-center d-md-block d-none">
                <img
                  className="register-business-img"
                  src={imgg}
                  alt="register business"
                />
              </div>
            </MDBRow>
            {/* </ThemeProvider>
            </CacheProvider> */}
          </div>
          {/* alert error */}
          <AlertError
            showAlert={errorAlert}
            text={`زبان کیبورد را به ${errorAlert} تغییر دهید.`}
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default RegisterBusinessStep1;
